module.exports = __webpack_public_path__ + "img/ico_government_money.f3e4a67.svg";